import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://jg06af-rb.myshopify.com/checkouts/cn/hWNBgSWxNKncE70n6Yb5rGLa/es-ar?_r=AQAByHkJ8jcZdIvEe0H8ZdDRIkXMpmN5rxgoS347IycFAIY&preview_theme_id=133867339873';
const solutions = [{
  icon: '✂️',
  title: 'Pasarás de dudar en cada corte a CREAR',
  desc: 'proyectos limpios, simétricos y 100% profesionales con total seguridad.'
}, {
  icon: '📖',
  title: 'Entenderás EL POR QUÉ de cada técnica:',
  desc: 'dominarás las herramientas, los tipos de cuero, las costuras y los acabados gracias a los 6 eBooks incluidos en tu paquete.'
}, {
  icon: '🎓',
  title: 'Alcanzarás una calidad de exhibición en cada proyecto.',
  desc: 'Ya seas principiante o un trabajador del cuero con experiencia, tus bolsos y billeteras tendrán un nivel de detalle que impactará a tus clientes y amigos.'
}, {
  icon: '⚡',
  title: 'Tendrás un taller digital de consulta inmediata para toda la vida.',
  desc: 'Todo está perfectamente organizado en Google Drive. Cuando te llegue la inspiración, abres tu biblioteca, descargas y comienzas a crear al instante.'
}];
export function Solutions() {
  return <section id="soluciones" className="bg-cream py-20 px-4 sm:px-6 lg:px-8 scroll-mt-12" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-169">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-leather-dark mb-4" data-id="element-170">
            ¿Qué Lograrás Con Este Recurso?
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto rounded-full" data-id="element-171"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-172">
          {solutions.map((sol, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-5 p-6 rounded-xl bg-green-50/50 border border-green-100 shadow-sm" data-id="element-173">
              <span className="text-3xl flex-shrink-0" data-id="element-174">{sol.icon}</span>
              <p className="text-gray-800 text-lg leading-relaxed" data-id="element-175">
                <strong className="text-green-800 font-semibold" data-id="element-176">
                  {sol.title}
                </strong>{' '}
                {sol.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}